<template>
  <div class="login-wrap">
    <b-card id="loginCard" class="scale-in-bl login-card" body-class="p-4">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show" id="formLogin">
        <img src="../../assets/img/phoenix-logo.png" class="card-logo" alt="Phoenix Bioinformatics">
        <h1 class="text-center mb-2">Login</h1>
        <h2 class="text-center mb-4">Phoenix Bioinformatics Usage Portal</h2>
        <b-form-group id="input-group-1" label-for="email">
          <b-form-input
            id="email"
            class="login-input"
            v-model="form.username"
            type="email"
            placeholder="E-mail"
            @change="onChangeEmail"
            required
            autofocus
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label-for="input-2">
          <b-form-input
            id="passord"
            class="login-input"
            v-model="form.password"
            placeholder="Password"
            type="password"
            required
            @change="onChangePwd"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex flex-wrap justify-content-between align-items-center my-3 login-small">
          <b-form-checkbox size="lg" value="remember" class="mr-3 login-remember">
            Remember Me
          </b-form-checkbox>
          <router-link to="/recover" class="forgotPassword">
            Forgot Password?
          </router-link>
        </div>

        <b-button
          v-if="!loading"
          type="submit"
          variant="primary"
          class="btn-block login-btn"
          >Login</b-button
        >
        <b-button v-if="loading" disabled variant="primary" class="btn-block login-btn"
          >...
        </b-button>
        <div v-if="errMsg != null" class="text-danger my-3 text-center">
          {{ errMsg }}
        </div>
        <div class="text-center mt-4 mb-2 login-small">
          <span class="mr-2">No Account?</span>
          <router-link to="/register" class="createAccount"
            >Register</router-link
          >
        </div>
        <div class="text-center my-2 login-small">
          <span class="mr-2">Need to reactivate account?</span>
          <router-link to="/reactivate" class="reactivateAccount">
            Reactivate
          </router-link>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      show: true,
      loading: false,
      errMsg: null,
    };
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
  },
  mounted() {
    if (this.$route.query.expired === "true") {
      this.errMsg = "Your session has expired. Please log in again.";
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.loading = true;
      this.errMsg = null;

      this.$store.dispatch("login/signIn", this.form)
        .then((res) => {
          this.loading = false;

          const userSession = this.loggedInUser;
          this.$cookies.set("session", userSession, "24h");
          if (userSession && userSession.accessToken) {
            this.$store.dispatch("login/setSession", userSession);
            this.$router.push("/main");
          } else {
            this.errMsg = "Invalid session or access token.";
          }
        })
        .catch((err) => {
          console.log("err", err);
          this.loading = false;
          this.errMsg = err;
        });
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onChangeEmail(e) {
      // console.log(e);
      this.errMsg = null;
    },
    onChangePwd(e) {
      this.errMsg = null;
    },
  },
};
</script>

<style scoped>
.login-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  padding: 16px;
  overflow-y: auto;
}
.login-card {
  width: 100%;
  max-width: 440px;
  margin: auto;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
}
.login-card .card-logo {
  position: static;
  display: block;
  margin: 0 auto 12px;
}
/* The app sets a 10px root font size, so sizes here are in px. */
.login-card h1 {
  font-size: 28px !important;
  font-weight: 600;
}
.login-card h2 {
  font-size: 15px;
  font-weight: 400;
  color: #6c757d;
}
.login-card .login-input {
  height: 48px;
  padding: 0 14px;
  font-size: 16px;
}
.login-card .login-btn {
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
}
.login-small,
.login-card .login-remember {
  font-size: 14px;
}
</style>

<style>
.error-msg {
  color: red;
  font-size: 14px;
}
h1 {
  font-size: 3em !important;
}
.input {
  font-size: 1.5em !important;
}
.mt-3.mb-3 {
  font-size: 1.5em !important;
}
.remember {
  height: 10px;
  width: 200px;
  vertical-align: middle;
}
.card-logo {
    position: absolute;
    top: 10px;
    right: 10px;
    /* width: 5%;
    height: 5%; */
}
body {
  background-color:  #3d8cbc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/FormLogin.vue